"use client";

import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import SegmentedControl, {
   type SegmentedControlOption,
} from "@/components/library/SegmentedControl";
import {SmsProviderType} from "@/types/settings";

const PROVIDER_ORDER: SmsProviderType[] = ["twilio", "quickly", "directo"];

interface ProviderTypePickerProps {
   value: SmsProviderType;
   onChange: (provider: SmsProviderType) => void;
}

export default function ProviderTypePicker({value, onChange}: ProviderTypePickerProps) {
   const {t} = useTranslation("partners");
   const label = t("smsIntegration.form.provider");

   const options = useMemo<SegmentedControlOption<SmsProviderType>[]>(
      () =>
         PROVIDER_ORDER.map((provider) => ({
            key: provider,
            label: t(`smsIntegration.provider.${provider}`),
            dataTestId: `provider-${provider}`,
         })),
      [t]
   );

   return (
      <div className="flex items-center">
         <span className="text-sm font-medium text-700 mr-3">{label}</span>
         <SegmentedControl
            options={options}
            value={value}
            onChange={onChange}
            ariaLabel={label}
         />
      </div>
   );
}
